import FeatureFlag from './FeatureFlag';

class ExcludeVICFeatureFlag extends FeatureFlag {
    isExcludeVICEntitlements() {
        return 'exclude vic entitlements' === this.getFeatureFlagVal()?.toString()?.toLowerCase();
    }
}

export default ExcludeVICFeatureFlag;
